import { useEffect, useState } from "react";

interface TypingPlaceholderProps {
  phrases: string[];
  typingSpeed?: number;
  deleteSpeed?: number;
  pauseDuration?: number;
  className?: string;
}

const TypingPlaceholder: React.FC<TypingPlaceholderProps> = ({ 
  phrases, 
  typingSpeed = 50, // Increased typing speed (was 100)
  deleteSpeed = 25, // Increased deletion speed (was 50)
  pauseDuration = 1000, // Shortened pause duration (was 1500)
  className
}: TypingPlaceholderProps) => {
  const [text, setText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    
    if (isTyping) {
      if (text.length < phrases[phraseIndex].length) {
        timeout = setTimeout(() => {
          setText(phrases[phraseIndex].slice(0, text.length + 1));
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, pauseDuration);
      }
    } else {
      if (text.length > 0) {
        timeout = setTimeout(() => {
          setText(text.slice(0, -1));
        }, deleteSpeed);
      } else {
        setPhraseIndex((current) => (current + 1) % phrases.length);
        setIsTyping(true);
      }
    }

    return () => clearTimeout(timeout);
  }, [text, isTyping, phraseIndex, phrases, typingSpeed, deleteSpeed, pauseDuration]);

  return <span className={`text-gray-400 ${className || ''}`}>{text}</span>;
};

export default TypingPlaceholder;
